import React from "react";
import InfoBox from '../components/info.js'
import Panoramic from "../components/panoramic.js";
import PhotoBas from './../../images/A4Bas_Ilot Sommet (LouisAudet).jpg'

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={PhotoBas} alt="" />
            <InfoBox>Affluence de militants à l&#39;occasion du Sommet des Amériques. Photographie de Louis Audet, avril 2001.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-axe4.js